import React from 'react';
import { FaLaptop, FaClock, FaShieldAlt, FaCheckCircle } from 'react-icons/fa';
import '../styles/OnlineNotarization.css';

const OnlineNotarization = () => {
  const features = [
    {
      icon: <FaLaptop />,
      title: 'Convenient',
      description: 'Get your documents notarized from anywhere using your computer or mobile device'
    },
    {
      icon: <FaClock />,
      title: 'Fast',
      description: 'Complete the process in minutes without traveling to an office'
    },
    {
      icon: <FaShieldAlt />,
      title: 'Secure',
      description: 'Bank-level encryption and identity verification for maximum security'
    },
    {
      icon: <FaCheckCircle />,
      title: 'Legal',
      description: 'Fully compliant with Washington state notary laws and regulations'
    }
  ];

  return (
    <section className="section online-section">
      <div className="container">
        <h2 className="section-title">Online Notarization</h2>
        <p className="section-subtitle">
          Get your documents notarized remotely with our secure online platform
        </p>
        <div className="online-features">
          {features.map((feature, index) => (
            <div className="feature-card" key={index}>
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
        <div className="online-cta">
          <a href="tel:2065664676" className="btn btn-primary">
            Schedule Online Notarization
          </a>
        </div>
      </div>
    </section>
  );
};

export default OnlineNotarization;